import React from 'react';
import { Popover as AntPopover, PopoverProps } from 'antd';
import { ClassNames, ClassNamesContent } from '@emotion/react';

const Popover = React.forwardRef<unknown, PopoverProps>(({ children, ...props }, ref) => 
  <ClassNames>
    {(ctx) => (
      <AntPopover {...props} ref={ref} overlayClassName={getCSS(ctx)}>
        {children}
      </AntPopover>
    )}
  </ClassNames>
);

const getCSS = ({ css }: ClassNamesContent) => css`
  & .ant-popover-inner-content {
    padding: 6px 8px;
  }
`;

export default Popover;
